import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import AgentForm from "./AgentForm";
import API_BASE_URL from "../../config/api";
import {
  Typography,
  Row,
  Col,
  Card,
  Button,
  Spin,
  Empty,
  Table,
  Modal,
  Space,
  Tag,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomPagination from "../paginations/CustomPagination";
const { Title, Text } = Typography;
const AgentList = () => {
  const [agents, setAgents] = useState([]);
  const [agentCount, setAgentCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [agentToDelete, setAgentToDelete] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () =>
    // page = pagination.current,
    // pageSize = pagination.pageSize
    {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/agents`, {
          headers: { Authorization: token },
          // params: {
          //   page,
          //   limit: pageSize,
          // },
        });

        if (response.data.success) {
          setAgents(response.data.data);
          // setPagination({
          //   current: page,
          //   pageSize: pageSize,
          //   total: response.data.count,
          // });
          setPagination((prev) => ({
            ...prev,
            total: response.data.data.length,
          }));
        }
      } catch (err) {
        setError("Failed to fetch agents");
      } finally {
        setLoading(false);
      }
    };

  const handleTableChange = (newPagination) => {
    setPagination({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const handlePageSizeChange = (newPageSize) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: newPageSize,
      current: 1, // Reset to first page when page size changes
    }));
  };

  const handleAddAgent = () => {
    setEditingAgent(null);
    setShowForm(true);
  };

  const handleEditAgent = (agent) => {
    setEditingAgent(agent);
    setShowForm(true);
  };

  const showDeleteModal = (agent) => {
    setAgentToDelete(agent);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteAgent = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_BASE_URL}/agents/${agentToDelete.id}`, {
        headers: {
          Authorization: token,
        },
      });
      fetchAgents(); // Refresh the list
      setIsDeleteModalVisible(false);
      setAgentToDelete(null);
    } catch (err) {
      setError("Failed to delete agent");
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingAgent(null);
  };

  const handleFormSubmit = () => {
    setShowForm(false);
    setEditingAgent(null);
    fetchAgents();
  };

  // const columns = [
  //   {
  //     title: "Agent",
  //     dataIndex: "name",
  //     key: "name",
  //     render: (name) => (
  //       <div className="flex items-center gap-3">
  //         <div
  //           className="ant-avatar ant-avatar-circle ant-avatar-sm"
  //           style={{ backgroundColor: "#E6F7FF", color: "#1890FF" }}
  //         >
  //           {name.charAt(0).toUpperCase()}
  //         </div>
  //         <strong>{name}</strong>
  //       </div>
  //     ),
  //   },
  //   // {
  //   //   title: "Email",
  //   //   dataIndex: "email",
  //   //   key: "email",
  //   // },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     key: "status",
  //     render: (status) => (
  //       <Tag
  //         style={{
  //           minWidth: "100px",
  //           textAlign: "center",
  //           display: "inline-block",
  //           color: status === "active" ? "#389e0d" : "#595959",
  //           backgroundColor: status === "active" ? "#f6ffed" : "#fafafa",
  //           borderColor: status === "active" ? "#b7eb8f" : "#d9d9d9",
  //         }}
  //       >
  //         {(status || "N/A").toUpperCase()}
  //       </Tag>
  //     ),
  //   },
  //   {
  //     title: "Created",
  //     dataIndex: "created_at",
  //     key: "created_at",
  //     render: (date) => dayjs(date).format("DD-MM-YYYY"),
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (_, agent) => (
  //       <Space size={4}>
  //         {/* <Button
  //           type="text"
  //           icon={<EditOutlined style={{ color: "green" }} />}
  //           onClick={() => handleEditAgent(agent)}
  //         /> */}
  //         <Button
  //           type="text"
  //           danger
  //           icon={<DeleteOutlined />}
  //           onClick={() => showDeleteModal(agent)}
  //         />
  //       </Space>
  //     ),
  //   },
  // ];

  return (
    <div className="p-4">
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Agent Management
        </Title>
        <Text type="secondary" style={{ fontSize: 16 }}>
          Manage your AI calling agents and their configurations
        </Text>
      </div>

      {loading ? (
        <Spin tip="Loading agents..." />
      ) : (
        <>
          {error && (
            <div style={{ marginBottom: 16, color: "red" }}>{error}</div>
          )}

          {agents.length === 0 ? (
            <Empty description="No agents found">
              <Button type="primary" onClick={handleAddAgent}>
                Create Your First Agent
              </Button>
            </Empty>
          ) : (
            <>
              <div className="rounded-2 table-responsive">
                <table
                  className="table align-middle mb-0 shadow-sm"
                  style={{ tableLayout: "auto" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th>Agent</th>
                      <th>Status</th>
                      <th>Created</th>
                      {/* <th style={{ width: "100px" }}>Actions</th>{" "} */}
                      {/* fixed width */}
                    </tr>
                  </thead>
                  <tbody>
                    {agents
                      .slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                      )
                      .map((agent, index) => (
                        <tr key={agent.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div
                                className="rounded-circle me-2"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  backgroundColor: "#E6F7FF",
                                  color: "#1890FF",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {agent.name?.charAt(0).toUpperCase()}
                              </div>
                              <span style={{ fontWeight: 600 }}>
                                {agent.name}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                agent.status === "active"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {(agent.status || "N/A").toUpperCase()}
                            </span>
                          </td>
                          <td>
                            {dayjs(agent.created_at).format("DD-MM-YYYY")}
                          </td>
                          {/* <td
                          style={{ paddingRight: "8px", whiteSpace: "nowrap" }}
                        >
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => showDeleteModal(agent)}
                          >
                            Delete
                          </button>
                        </td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end">
                <CustomPagination
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onPageChange={(page) => {
                    setPagination((prev) => ({ ...prev, current: page }));
                  }}
                  onPageSizeChange={handlePageSizeChange}
                />
              </div>
            </>
          )}

          <Modal
            title="Delete"
            open={isDeleteModalVisible}
            onOk={handleDeleteAgent}
            onCancel={() => setIsDeleteModalVisible(false)}
            okText="Delete"
            cancelText="Cancel"
            okButtonProps={{
              style: { backgroundColor: "red", borderColor: "red" },
            }}
          >
            <p>Are you sure you want to delete this Agent?</p>
          </Modal>

          <Modal
            title={editingAgent ? "Edit Agent" : "Create New Agent"}
            open={showForm}
            onCancel={handleFormClose}
            footer={null}
            width={600}
            destroyOnClose={true}
          >
            <AgentForm
              agent={editingAgent}
              onClose={handleFormClose}
              onSubmit={handleFormSubmit}
            />
          </Modal>
        </>
      )}
    </div>
  );
};

export default AgentList;
